import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-datasource';
import { APCourse } from '../../../builders/ap_course_builder';
import { APCourseGroup } from '../../../builders/ap_course_group_builder';
import { APProgramSlot, IAPProgramSlotMeta } from '../../../builders/ap_program_slot_builder';
import { IAPProgramSlotDatasource } from '../../../datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../../datasources/ap_terms_datasource';
import { APCommandUrlServant } from '../../../servants/ap_command_url_servant';
import { APProgramSlotServant } from '../../../servants/ap_program_slot_servant';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'removeCourseGroupFromTermAndAddCourseCommand',
    function removeCourseGroupFromTermAndAddCourseCommand(
      log: any,
      $http: ng.IHttpService,
      ngAPPlannedCourseGroupDatasource: any,
      ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
      ngAPCoursesDatasource: any,
      ngAPPlannedCoursesDatasource: any,
      ngAPCommandUrlServant: APCommandUrlServant,
      defineCommandORM: IDefineCommand
    ): ICommand {
      return defineCommandORM(
        'removeCourseGroupFromTermAndAddCourseCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          programSlot: APProgramSlot & IAPProgramSlotMeta,
          courseGroup: APCourseGroup,
          courseToPlan: APCourse,
          courseNk = null,
          source: string = 'PLANNER'
        ): void => {
          const academicPlanUrl = ngAPCommandUrlServant.get('academicPlan');
          const courseGroupUrl = ngAPCommandUrlServant.get('courseGroup');

          $http
            .delete(`${courseGroupUrl}/${courseGroup.id}`)
            .then((response: any) => {
              ngAPPlannedCourseGroupDatasource.del(courseGroup.id);
              APProgramSlotServant.updateCourseGroupPlannedState(ngAPProgramSlotDatasource, courseGroup.program_slot);

              const slot = programSlot;
              const isDevReq = !APProgramSlotServant.isNCRProgramSlot(programSlot) && !!programSlot.is_devreq;
              const payload = {
                course_id: courseToPlan.id,
                term_id: programSlot._term_id,
                slot_id: _4.isEmpty(slot) || slot.slot < 1 || isDevReq ? null : slot.id,
                course_nk: courseNk,
                source
              };

              $http
                .post(academicPlanUrl, payload)
                .then((secondResponse: any) => {
                  _4.each(response.data.conflict_course, (plannedCourse: APCourse) => {
                    ngAPCoursesDatasource.put(plannedCourse);
                  });
                  ngAPCoursesDatasource.write(secondResponse.data.course);
                  ngAPPlannedCoursesDatasource.clear().write(secondResponse.data.planned_course);

                  deferred.resolve();
                })
                .catch((error: any) => {
                  log.issue('failed to save course to term');
                  deferred.reject(error.data);
                });
            })
            .catch((e: any) => {
              log.issue('failed to remove course group');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_button/commands/remove_course_group_from_term_and_add_course_command.ts